import React from "react";
import { Tooltip, Icon } from "antd";
// 最新资讯表头
const columns = [
  {
    title: "标题",
    dataIndex: "title",
    key: "title",
    width: 330,
    render: text => {
      if (text.length <= 20) {
        return <span>{text}</span>;
      }
      return (
        <Tooltip placement="top" title={text}>
          <span>{text.substring(0, 20)}...</span>
        </Tooltip>
      );
    }
  },
  {
    title: "发布组织",
    dataIndex: "orgname",
    key: "orgname",
    width: 200
  },
  {
    title: "发布时间",
    dataIndex: "publishTime",
    key: "publishTime",
    width: 160
  }
];
// 热门资讯表头
const HotColumns = [
  {
    title: "标题",
    dataIndex: "title",
    key: "title",
    width: 360,
    render: text => {
      if (text.length <= 20) {
        return <span>{text}</span>;
      }
      return (
        <Tooltip placement="top" title={text}>
          <span>{text.substring(0, 20)}...</span>
        </Tooltip>
      );
    }
  },
  {
    title: (
      <div>
        阅读次数&nbsp;
        <Tooltip title="阅读次数为用户查看文章次数的总和">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: "clickCount",
    key: "clickCount",
    width: 150
  },
  {
    title: (
      <div>
        点赞数&nbsp;
        <Tooltip title="点赞数为用户点赞的总次数，外链文章阅读点赞次数暂无法统计">
          <Icon type="question-circle" />
        </Tooltip>
      </div>
    ),
    dataIndex: "praiseCount",
    key: "praiseCount",
    width: 150,
    render: (text, record) => {
      return !Number(record.newsType) ? text : "-";
    }
  },
  {
    title: "发布组织",
    dataIndex: "orgname",
    key: "orgname",
    width: 200
  },
  {
    title: "发布时间",
    dataIndex: "publishTime",
    key: "publishTime",
    width: 160
  }
];

export { columns, HotColumns };
